__turbopack_context__.v({
  "bullets": "services-ring-module__Ya431G__bullets",
  "caption": "services-ring-module__Ya431G__caption",
  "card": "services-ring-module__Ya431G__card",
  "carousel": "services-ring-module__Ya431G__carousel",
  "close": "services-ring-module__Ya431G__close",
  "control": "services-ring-module__Ya431G__control",
  "controls": "services-ring-module__Ya431G__controls",
  "direction": "services-ring-module__Ya431G__direction",
  "eyebrow": "services-ring-module__Ya431G__eyebrow",
  "ground": "services-ring-module__Ya431G__ground",
  "heading": "services-ring-module__Ya431G__heading",
  "item": "services-ring-module__Ya431G__item",
  "link": "services-ring-module__Ya431G__link",
  "modal": "services-ring-module__Ya431G__modal",
  "modalCaption": "services-ring-module__Ya431G__modalCaption",
  "modalCopy": "services-ring-module__Ya431G__modalCopy",
  "modalImage": "services-ring-module__Ya431G__modalImage",
  "photo": "services-ring-module__Ya431G__photo",
  "ring": "services-ring-module__Ya431G__ring",
  "section": "services-ring-module__Ya431G__section",
  "soon": "services-ring-module__Ya431G__soon",
  "stage": "services-ring-module__Ya431G__stage",
  "tag": "services-ring-module__Ya431G__tag",
  "watermark": "services-ring-module__Ya431G__watermark",
});
